import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SlackIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M3.95147 9.85032C3.95147 10.664 3.29435 11.3217 2.48131 11.3217C1.66826 11.3217 1.01114 10.664 1.01114 9.85032C1.01114 9.03663 1.66826 8.37898 2.48131 8.37898H3.95147V9.85032ZM4.68656 9.85032C4.68656 9.03663 5.34368 8.37898 6.15672 8.37898C6.96977 8.37898 7.62689 9.03663 7.62689 9.85032V13.5287C7.62689 14.3424 6.96977 15 6.15672 15C5.34368 15 4.68656 14.3424 4.68656 13.5287V9.85032Z"
		></path>
		<path
			fill="currentColor"
			d="M9.84327 12.0573C10.6563 12.0573 11.3134 12.715 11.3134 13.5287C11.3134 14.3424 10.6563 15 9.84327 15C9.03023 15 8.37311 14.3424 8.37311 13.5287V12.0573H9.84327ZM9.84327 11.3217C9.03023 11.3217 8.37311 10.664 8.37311 9.85032C8.37311 9.03663 9.03023 8.37898 9.84327 8.37898H13.5298C14.3429 8.37898 15 9.03663 15 9.85032C15 10.664 14.3429 11.3217 13.5298 11.3217H9.84327Z"
		></path>
		<path
			fill="currentColor"
			d="M12.0485 6.16083C12.0485 5.34713 12.7056 4.68949 13.5187 4.68949C14.3317 4.68949 14.9889 5.34713 14.9889 6.16083C14.9889 6.97452 14.3317 7.63217 13.5187 7.63217H12.0485V6.16083ZM11.3134 6.16083C11.3134 6.97452 10.6563 7.63217 9.84327 7.63217C9.03023 7.63217 8.37311 6.97452 8.37311 6.16083V2.47134C8.37311 1.65764 9.03023 1 9.84327 1C10.6563 1 11.3134 1.65764 11.3134 2.47134V6.16083Z"
		></path>
		<path
			fill="currentColor"
			d="M6.15672 3.94268C5.34368 3.94268 4.68655 3.28503 4.68655 2.47134C4.68655 1.65764 5.34368 1 6.15672 1C6.96977 1 7.62689 1.65764 7.62689 2.47134V3.94268H6.15672ZM6.15672 4.68949C6.96977 4.68949 7.62689 5.34713 7.62689 6.16083C7.62689 6.97452 6.96977 7.63217 6.15672 7.63217H2.47017C1.65712 7.63217 1 6.97452 1 6.16083C1 5.34713 1.65712 4.68949 2.47017 4.68949H6.15672Z"
		></path>
	</svg>
))
